import { CommonModule } from '@angular/common';
import { Component , EventEmitter, inject, Output} from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [CommonModule, MenuModule ,ButtonModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {

 headerBg: '#F6F9FE' | 'solid' = 'solid';
  private router = inject(Router);
  private ar = inject(ActivatedRoute);

  constructor() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => {
        let r = this.ar;
        while (r.firstChild) r = r.firstChild; // deepest child
        return r;
      }),
      mergeMap(r => r.data)
    ).subscribe(data => this.headerBg = (data['headerBg'] as any) ?? '#fff');
  }
  mobileOpen = false;

openMobile() {
  // this.mobileOpen = true;
  this.mobileOpen = !this.mobileOpen;
  
  document.body.style.overflow = 'hidden'; // يمنع سكرول الخلفية
}

closeMobile() {
  this.mobileOpen = false;
  document.body.style.overflow = '';
}

//////for qr popup///////
 appleUrl  = 'https://apps.apple.com/your-app';
  googleUrl = 'https://play.google.com/store/apps/details?id=your.app';

  // صفحة موحّدة للتنزيل نولّد منها QR (أو استخدمي صورة ثابتة)
  qrData = 'https://studiflats.example/download';
  qrImg: string = 'images/home/qrImg.svg'; // بدّليها أو خلّيها توليد

  qrMenuItems:any = [
    { label: '', styleClass: 'qr-header', header: true },
    {img:'images/home/appleBtn.svg', label: 'Apple Store',  icon: 'pi-apple',  url: this.appleUrl,  target: '_blank'  },
    {img:'images/home/googleBtn.svg', label: 'Google Play',  icon: 'pi-google', url: this.googleUrl, target: '_blank' }
  ];

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

} 
